import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import { Trad } from './';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import * as Glob from '../Globale';
import { Prodotti } from '../components/';

interface IAccordionProdottiProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON;
    Abilitato: boolean;
    CampoPreventivoSelezionato: string;
    Indice: number;
    Forzabili?: boolean;
    DimensioneMinima?: number;
    ProductsHeaderVisible?: boolean;
    ProductsBodyVisible?: boolean;
    ShowOnlySelected?: boolean;
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label: string, fieldTypeId: number, elementGroup: any) => any;
}

export class AccordionProdotti extends BasePureComponent<IAccordionProdottiProps> {

    private _Name: string;
    private _Id: string;

    public constructor(props: any) {
        super(props);
    }

    public render() {

        if (this.props.Name == "PolizzeJSON")
            this._Name = this.props.Name;
        else
            this._Name = this.props.Name + ".PolizzeJSON";

        if (this.props.Id == "PolizzeJSON")
            this._Id = this.props.Id;
        else
            this._Id = this.props.Id + ".PolizzeJSON";

        return <div className="card-header" data-toggle="collapse">
            <a href="#kt_accordion_1_item_2_body" onClick={(e) => {
                e.preventDefault()
            }} className="card-title collapsed hidden-accordion-icon" role="tab"
                aria-expanded="false">
                <span className="accordion__item-icon"><i
                    className="fa flaticon-file-2"></i></span>
                <span className="accordion__item-icon">{Trad.Trad("Preventivi")}</span>
            </a>
            <div
                className={this.props.Value != undefined && this.props.Value != "" && this.props.Value !== "[]"
                    ? "kt-accordion__itekt-body collapse show" : "kt-accordion__itekt-body collapse"}
                id={"kt_accordion_1_item_" + this.props.Indice + "_body"} role="tabpanel"
                aria-labelledby={"kt_accordion_1_item_" + this.props.Indice + "_head"}>
                <div className="form-group accordion-form login-form__group row">
                    <Prodotti
                        Id={this._Id}
                        Name={this._Name}
                        OnChange={this.props.OnChange}
                        Value={this.props.Value}
                        Abilitato={this.props.Abilitato}
                        CampoPreventivoSelezionato={this.props.CampoPreventivoSelezionato}
                        Forzabili={this.props.Forzabili}
                        DimensioneMinima={this.props.DimensioneMinima}
                        HeaderVisible={this.props.ProductsHeaderVisible}
                        BodyVisible={this.props.ProductsBodyVisible}
                        ShowOnlySelected={this.props.ShowOnlySelected}
                        OnChangeAppendice={this.props.OnChangeAppendice}
                    />
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/AccordionProdotti.tsx